import React, { forwardRef, Fragment, useEffect, } from "react";
import {ReactComponent as Resume} from "../../../assets/media_icons/resume.svg";
import {ReactComponent as Pause} from "../../../assets/media_icons/pause.svg";
import "./MediaPlayer.css";
import MediaPlayer from "./MediaPlayer";
import { useMediaRecorder } from "../MediaComponent/useMediaRecorder";
import { calculateTime } from "../../../utils/mediaUtils";

const ControlledMediaPlayer = forwardRef(
    (
        {
            mode = "audio",
            disabled = false,
            mediaUrl = "",
            autoPlay = true,
        }, 
        ref
    ) => 
    {

    const {
        time,
        setTime,
        maxValue,
        setMaxValue,
        seekProgress,
        isPlaying,
        setIsPlaying,
        handleTogglePause,
        handleMediaTimeUpdated,
        handleSeek,
        handleEnded
    } = useMediaRecorder({
        mediaRef: ref,
        mediaUrl,
    })

    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const cacheMediaoRef = ref.current;

        const handleLoadedMetadata = () => {
            if (ref.current.readyState > 0) {
                setIsPlaying(autoPlay);
                // FIXME: Firefox displays Infinity:NaN       
                setMaxValue(Math.ceil(ref.current.duration));
                setTime(calculateTime(ref.current.duration));
            }
        }

        cacheMediaoRef.addEventListener('loadedmetadata', handleLoadedMetadata);

        return () => {
            if (cacheMediaoRef) {
                cacheMediaoRef.removeEventListener('loadedmetadata', handleLoadedMetadata);
            }
        }
    }, [setMaxValue, setTime])

    if(!mediaUrl) return null;

    return (
        <Fragment>
            <MediaPlayer 
                time={time}
                disabled={disabled}
                progress={seekProgress}
                maxValue={maxValue}
                onChangeSeekBar={handleSeek}
                leftElement={
                    <button className="media-play-button" onClick={handleTogglePause}>
                        {isPlaying ?
                        <Pause height={30} width={30} />
                        :
                        <Resume height={30} width={30} />
                        }
                    </button>
                }
            />
            {mode === "audio" &&                  
                <audio ref={ref} autoPlay={autoPlay} onTimeUpdate={handleMediaTimeUpdated} onEnded={handleEnded}>
                    <source src={mediaUrl} type="audio/mp4" />    
                </audio>
            }
        </Fragment>
    )
})

export default ControlledMediaPlayer;